_theme.AddReadMore = function(){
  //This limit you can set after how much characters you want to show Read More.
  var carLmt = 130;
  // Text to show when text is collapsed
  var readMoreTxt = " Read More";
  // Text to show when text is expanded
  var readLessTxt = " Read Less";

  //Traverse all selectors with this class and manupulate HTML part to show Read More
  $(".addReadMore").each(function() {
    if ($(this).find(".firstSec").length)
      return;

    var allstr = $(this).text();
    if (allstr.length > carLmt) {
      var firstSet = allstr.substring(0, carLmt);
      var secdHalf = allstr.substring(carLmt, allstr.length);
      var strtoadd = firstSet +'...'+ "<span class='SecSec'>" + secdHalf + "</span><span class='readMore'  title='Click to Show More'>" + readMoreTxt + "</span><span class='readLess' title='Click to Show Less'>" + readLessTxt + "</span>";
      $(this).html(strtoadd);
    }
  });
  //Read More and Read Less Click Event binding
  $(document).on("click", ".readMore,.readLess", function() {
      $(this).closest(".addReadMore").toggleClass("showlesscontent showmorecontent");
  });
}
// Click event
_theme.clickEvent = function() {
  $(document).on('click', '.site-footer__section-title', function(){
    if (window.matchMedia('(max-width: 767px)').matches) {
      $(".site-footer__section-title").removeClass('open');
      $(".site_footer_col_content").css("display","none");
      if($(this).closest('.site-footer__section').find('.site_footer_col_content').css('display') == 'none'){
        $(this).addClass('open');
        $(this).closest('.site-footer__section').find('.site_footer_col_content').slideToggle();
      }else{
        $(this).removeClass('open');
        $(this).closest('.site-footer__section').find('.site_footer_col_content').slideToggle();
      }
      
    }
  });

  // Show reset password form
  $(document).on('click', '#RecoverPasswordBtn', function(evt) {
    evt.preventDefault();
    $(this).closest(".content-block").find('#RecoverPasswordForm').removeClass('hide');
    $(this).closest(".content-block").find('#CustomerLoginForm').addClass('hide');
  });

  // Hide reset password form
  $(document).on('click','#HideRecoverPasswordLinkBtn', function(evt) {
    evt.preventDefault();
    $(this).closest(".content-block").find('#RecoverPasswordForm').addClass('hide');
    $(this).closest(".content-block").find('#CustomerLoginForm').removeClass('hide');
  });
  
  // Wishlist redirect to logi page
  $(document).on('click','.swym_button_without_login', function(evt) {
    window.location = "/account/login";
  });
  
  // wishlist count
  $(".swym-add-to-wishlist-view-product").bind("click touchstart",function(){
    setTimeout(function() {
      window._swat.wishlistCount(
        function(r) {
          $(".swym-wishlist-count").text(r);
        }
      );
    },2500);
  });
  
  // sidecart click event
  $(document).click(function(){
    var container = $(".site-header__cart,.site-header__cart.active");
    if (!container.is(event.target) && !container.has(event.target).length) {
      $(".js-mini-cart.active").removeClass('active');
    }
  });
  
  // collection filter open 
  $(document).on("click",".ais-page .ais-facet--header", function(){
     $(this).find('~ div').slideToggle();
     $(this).toggleClass("active");
  });

  //   close filter drawer
  $(document).on("click", ".black-bg", function(){
  	$(this).closest(".ais-page").removeClass("open");
    $(".ais-facets").removeClass("ais-facets__shown");
  });
};

// iconAndTextSlickSlider 
_theme.iconAndTextSlickSlider = function() {
  var target = $(".icons-and-text-inner-wrap");
  if(target.length > 0) {
    $('.icons-and-text-inner-wrap').slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }    
      ]
    });
  }
}

//  theme load
_theme.load = function() {
  $(window).on('load', function () {
	//  Wishlist count added
    setTimeout(function() {
      window._swat.wishlistCount(
        function(r) {
          $(".swym-wishlist-count").text(r).addClass('active');
        }
      );
    },2500); 
  });
}

//  checkPaginaionPage
_theme.checkPaginaionPage = function() {
  var checkPaginaionPage = setInterval(function(){ 
    var paginationTarget = $(".ais-Pagination-list .ais-Pagination-item--page");
    if($(paginationTarget).length == 1){
      $(".ais-pagination-container").css({
        "height": "0",
        "margin": "0",
        "visibility": "hidden"
      });
      clearInterval(checkPaginaionPage);
    }
  }, 1000);
}

// collection image set height and width
_theme.collectionImg = function(){
  document.addEventListener('readystatechange', event => { 
    // When window loaded ( external resources are loaded too- `css`,`src`, etc...) 
    if (event.target.readyState === "complete") {
      var imgTarget =  $( ".product-card:first" ).find(".transition");
      $(".product-card").each(function(){
        var currentImg = $(this).find(".transition"),
            imgWidth = imgTarget.width(),
            imgHeight = imgTarget.height();
        $(currentImg).css({
          "width" : imgWidth,
          "height" : imgHeight 
        });
      });
    }
  });
}

_theme.initNewsletterPopup = function(){
  $('#jsPopupNewsletter form .js-btnPopupNewsletter').click(function(evt){
    evt.preventDefault();
    var patt = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    var $form = $(this).closest('form');
    var $formerr = $form.find('.form-err');
    var email = $form.find('#popupNewsletter').val().trim();
    var isValid = true;
    
    if(email == ''){
      isValid = false;
      $formerr.text('Please enter your email')
    } else {
      if(!patt.test(email)){
        isValid = false;
        $formerr.text('Invalid email');
      }
    }
    
    if(!isValid){
      $formerr.addClass('show');
      return;
    } else {
      $formerr.text('').removeClass('show');
      $form.submit();
    }
 });
}

// $( window ).resize(function() {
//   _theme.collectionImg();
// });

//  init 
_theme.init = function() {
  _theme.clickEvent();
  _theme.iconAndTextSlickSlider();
  _theme.checkPaginaionPage();
  _theme.AddReadMore();
  _theme.initNewsletterPopup();
//   _theme.collectionImg();
};

// Document ready 
$(document).ready(function(){
  _theme.init();
  _theme.load();
});